import { createContext, useState, useCallback, useContext, useEffect, useRef } from "react";
import axios from 'axios';
import { convertDateToFormat } from "../components/utils/utils";
import { AuthContext } from "./AuthContext";
import { getDomains } from '../components/utils/utils';



const tabs = [
    { name: 'Open', href: '#', count: '0', current: true },
    { name: 'In Progress', href: '#', count: '0', current: false },
    { name: 'Resolved', href: '#', count: '0', current: false },
    { name: 'Closed', href: '#', count: '0', current: false }
]




const defaultContext = {
  tickets: [],
  singleTicket: null,
  fetchData: () => {},
  handleSingleTicket: () => {},
  handleSwitchTab: () => {},
  countTicket: () => {},
  loading: false,
  submitLoader: false,
  ticketsCount: [],
  tabs: [],
  currentTab: "Open",
  totalPages: 1,
  currentPage: 1,
  handleNextPagination: () => {},
  handlePrevPagination: () => {}
};

const API_BASE_URL = process.env.REACT_APP_SUPPORT_API_BASE_URL;

export const SupportContext = createContext(defaultContext);

export const SupportProvider = ({children}) => {
    const [loading, setLoading] = useState(false);
    const [submitLoader, setSubmitLoader] = useState(false);
    const [tickets, setTickets] = useState([]);
    const [singleTicket, setSingleTicket] = useState(null);
    const [transactionHistory, setTransactionHistory] = useState(null);
    const [ticketsCount, setTicketsCount] = useState([]);
    const [currentTab, setCurrentTab] = useState("Open");
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [responseTextGiven, setResponseTextGiven] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [userTab, setUserTab] = useState(1)

    const [selectedProduct, setSelectedProduct] = useState(() => {
      return getDomains().find(item => item.id === 12) || null;
    });

    //const [ticketStatus, setTicketStatus] = useState("Open")

    const { authUserData } = useContext(AuthContext);
    const ticketsRequestRef = useRef(null);

    //  useEffect(()=> {
    //         fetchData(currentTab, currentPage, searchText, dateValue);  
    //   },[selectedProduct])

    //console.log(getDomains());

    const fetchData = async (status,currentpage,  searchText, dateValue) => {
        const title = (searchText || '').trim();
        if (title !== '' && title.length < 3) return;

        ticketsRequestRef.current?.abort();
        const controller = new AbortController();
        ticketsRequestRef.current = controller;
        setLoading(true);
        try {
          const start_date = dateValue?.startDate ? convertDateToFormat(dateValue?.startDate) : '';
          const end_date = dateValue?.endDate ? convertDateToFormat(dateValue?.endDate) : '';
          const current_page = currentpage || 1;
          const per_page = perPage || 10;
          setCurrentPage(current_page);
          //const selProd = productObj || selectedProduct

         //console.log(selProd)
          //console.log(dateValue)
          //const start_date = 
          const response = await axios.get(
            `${API_BASE_URL}tickets/${selectedProduct.id}?status=${status}&title=${title}&start_date=${start_date}&end_date=${end_date}&page=${current_page}&per_page=${per_page}`,
            { signal: controller.signal }
          );
          const data = response.data?.data?.tickets || {};
          const totalData = response.data?.data?.total || {};
            
          const addFields = data.map((row, i ) => {
                return {...row, selected: i === -1 ? true : false}
          });
           //console.log(addFields)
          setTickets(addFields);
          //setSingleTicket(data ? data[0] : []);
          //setSingleTicket([]);
          
          setTotalPages(totalData || 1);
        } catch (error) {
          if (controller.signal.aborted || error?.code === "ERR_CANCELED") return;
          console.error("Error fetching data:", error);
        } finally {
          if (ticketsRequestRef.current === controller) setLoading(false);
        }
    };

    const handleSingleTicket = async(id) => {
        const response = await axios.get(
            `${API_BASE_URL}ticket/show/${id}`,
            
          );
        const data = response.data?.data || {};
        //console.log(data)
        const copiedTicket = [...tickets];
        const updateField = copiedTicket.map((row) => {
            return {...row, selected: row.id === id ? true : false}
        });
        //const selectedTicket = updateField.filter((ele) => ele.id === id);
        setTickets(updateField);
        setSingleTicket(data ?? null);
        setUserTab(1)
        //setTicketStatus(tabName)
        //console.log(selectedTicket)
    }

    const handleUserTransactionHistory = async(userid) => {
        const response = await axios.get(
            `${API_BASE_URL}ticket/user/subscription?product_id=${selectedProduct.id}&user_id=${userid}`,
            
          );
        const data = response.data?.data || {};
        
        setTransactionHistory(data ?? null);
        //setTicketStatus(tabName)
        //console.log(selectedTicket)
    }

    const handleSwitchTab = (tabName) => {
        //console.log(tabName)
        //fetchData(tabName);
        //setCurrentTab(tabName);
        setCurrentTab(tabName);
        
        setCurrentPage(1); // Reset to page 1 on tab switch
        fetchData(tabName, 1); // Ensure fetchData is called with page 1
        
        const copiedTicketCount = [...ticketsCount]
        const newTicketCountStatus = copiedTicketCount.map((ele) => {
            return {
              ...ele,
              current: ele.name === tabName
            };
          });
        setTicketsCount(newTicketCountStatus)
        setSingleTicket(null)
        setUserTab(1)
        //handleNextPagination()
        //console.log(copiedTicketCountStatus)
    }

    const countTicket = async() => {
        const responseCount = await axios.get(
            `${API_BASE_URL}tickets/count/${selectedProduct.id}`,
            {
             /* start_date: selectedFilters?.start_date ||  
              null,
              end_date: selectedFilters?.end_date || null,
              page,
              per_page: perPage,
              search: query,*/
            }
          );
    
          
        const countData = responseCount.data?.data || {};
          

          // Helper map to convert status → count
        const countMap = {};
        countData.forEach(row => {
            countMap[row.status?.toLowerCase()] = row.count;
        });

        // Merge into tabs
        const mergedTabs = tabs.map(tab => {
            const key = tab.name.toLowerCase().replace(/\s+/g, '');
            const countKey = Object.keys(countMap).find(status =>
                status.replace(/\s+/g, '') === key
            );

            return {
                ...tab,
                count: countMap[countKey]?.toString() ?? '0',
                current: currentTab.toLowerCase() === key ? true : false
            };
        });
        
        setTicketsCount(mergedTabs || []);
        //console.log(mergedTabs)
        
    }

    const handlePrevPagination = () => {
      const newPage = Math.max(currentPage - 1, 1);
      setCurrentPage(newPage);
      fetchData(currentTab, newPage);
    };
    
    const handleNextPagination = () => {
      const newPage = Math.min(currentPage + 1, totalPages);
      setCurrentPage(newPage);
      fetchData(currentTab, newPage);
    };

    const changeTicketStatus = async (value) => {
      //console.log(value)
      //setSelected(value)
      //setTicketStatus(value)
      let ticketId = singleTicket.id
      const responseCount = await axios.get(
        `${API_BASE_URL}ticket/changestate?status=${value}&ticket_id=${ticketId}`
      );

      //const copiedTicket = [...singleTicket];
      const updateField = {...singleTicket, status: value}
      setSingleTicket(updateField);
      countTicket();
      //fetchData(currentTab,currentPage)
    }

    const addResponse = async (ticket) => {
      try {
        if (!responseTextGiven?.trim() ||responseTextGiven?.trim() === "") {
          alert("Response message cannot be empty.");
          return;
        }
        const formData = new FormData();
        setSubmitLoader(true);
        formData.append("ticket_id", String(ticket?.id || ""));
        formData.append(
          "responder_id",
          String(authUserData?.userData?.id || authUserData?.id || "")
        );
        formData.append("message", responseTextGiven?.trim() || "");

        if (selectedFile) {
          formData.append("support_image", selectedFile); // field name should match backend key
        }

        const respondData = await axios.post(
          `${API_BASE_URL}ticket/respond`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        setSubmitLoader(false);

        if (respondData.data?.code === 200) {
          setResponseTextGiven("");
          setSelectedFile(null);

          const response = await axios.get(
            `${API_BASE_URL}ticket/show/${ticket?.id}`,
            
          );
        const data = response.data?.data || {};
       
        setSingleTicket(data ?? null);

          alert("Response Added Successfully!");
          
        } else {
          const errors = respondData.data?.data?.errors;

          if (Array.isArray(errors)) {
            const messages = errors.map((errorObj) => {
              const firstKey = Object.keys(errorObj)[0];
              return errorObj[firstKey];
            });
            alert(messages.join("\n"));
          } else {
            alert("Something went wrong.");
          }
        }
      } catch (error) {
        console.error("Error in addResponse:", error);
        alert("Failed to submit response. Check console for details.");
      }
    };



    const handleSelectedProduct = (value) => {
      console.log(value)
        setSelectedProduct(value);
        console.log('updated')
    }

    const handleFileUpload = (file) => {
        if (file) {
            console.log("Selected file:", file);
            // You can store it in state or upload directly
            setSelectedFile(file);
        }
    };

    const resetFile = (e) => {
      e.stopPropagation(); // prevent opening file dialog
      setSelectedFile(null);
      
    };
    

    //console.log(currentTab)

    return (
        <SupportContext.Provider 
        value={{ 
          tickets, 
          singleTicket, 
          changeTicketStatus,
          //ticketStatus,
          fetchData,
          handleSingleTicket,
          handleSwitchTab,
          countTicket,
          addResponse,
          responseTextGiven,
          setResponseTextGiven,
          handleFileUpload,
          selectedFile,
          resetFile,
          loading,
          submitLoader,
          ticketsCount,
          tabs,
          currentTab,
          totalPages,
          currentPage, 
          handleNextPagination,
          handlePrevPagination,
          selectedProduct,
          handleSelectedProduct,
          handleUserTransactionHistory,
          transactionHistory,
          userTab, setUserTab 
          }}>
                {children}
        </SupportContext.Provider>
    )
}